declare namespace $ {

	export class $bog_fragile_demo_rename_heir1 extends $bog_fragile_demo_rename_base1 {
		heading( ): string
	}
	
}

//# sourceMappingURL=heir1.view.tree.d.ts.map